// src/components/Turmas/FiltrosTurma.js
import React from "react";

const FiltrosTurma = ({ turmas, filters, setFilters, fechar }) => (
  <div>
    <h2>Filtros</h2>
    <label>
      Ano:
      <select value={filters.ano} onChange={(e) => setFilters({ ...filters, ano: e.target.value })}>
        <option value="all">Todos</option>
        {[...Array(7)].map((_, i) => {
          const ano = 2024 + i;
          return <option key={ano} value={ano}>{ano}</option>;
        })}
      </select>
    </label>
    <label>
      Classe:
      <select value={filters.classe} onChange={(e) => setFilters({ ...filters, classe: e.target.value })}>
        <option value="all">Todas</option>
        {[...Array(12)].map((_, i) => (
          <option key={i} value={`${i + 1}ª Classe`}>{i + 1}ª Classe</option>
        ))}
      </select>
    </label>
    <label>
      Turma:
      <select value={filters.turma} onChange={(e) => setFilters({ ...filters, turma: e.target.value })}>
        <option value="all">Todas</option>
        {Object.keys(turmas).map((t) => (
          <option key={t} value={t}>{t}</option>
        ))}
      </select>
    </label>
    <button onClick={fechar}>Fechar</button>
  </div>
);

export default FiltrosTurma;
